async function fetchIPDetailss() {
    try {
        // Fetch IP address
        const response = await fetch('https://api.ipify.org?format=json');
        const data = await response.json();
        const ipAddress = data.ip;

        // Fetch location and time zone based on IP address
        const locationData = await fetchDataa(`https://ipapi.co/${ipAddress}/json/`);

        // Log IP address, location, and time zone to console
        // console.log("IP Address:", ipAddress);
        // console.log("Location:", locationData.city, locationData.region, locationData.country_name);
        // console.log("Time Zone:", locationData.timezone);

        // Call getUserCurrentAddress1 to display user's address based on IP
        const time = await getUserCurrentAddress1(locationData);
        // console.log('timeeeeeeee',time)
        const location = `${time}, ${locationData.city}, ${locationData.region}, ${locationData.country_name}, ${locationData.timezone}, ${ipAddress}`;
        // console.log('locationlocation',location)
      
        return location;
    } catch (error) {
        console.error('Error fetching IP details:', error);
    }
}

let apiEndpointt = "https://api.opencagedata.com/geocode/v1/json";
let apiKeyy = "cddb302a02314d828ac2651444bf6b44";

const fetchDataa = (url) => {
    return fetch(url)
        .then(response => response.json())
        .catch(error => console.error('Error fetching data:', error));
};

const getUserCurrentAddress1 = (locationData) => {
    const latitude = locationData.latitude;
    const longitude = locationData.longitude;

    let query = `${latitude},${longitude}`;
    let apiUrl = `${apiEndpointt}?key=${apiKeyy}&q=${query}&pretty=1`;

    return fetchDataa(apiUrl)
        .then(data => {
            console.log(data);
            const timestamp = new Date(data.timestamp.created_unix * 1000); 
            const formattedTimestamp = timestamp.toLocaleString(undefined, { timeZone: data.results[0].annotations.timezone.name });
            // console.log("Time:", formattedTimestamp)
            return formattedTimestamp;
        })
        .catch(error => console.error('Error getting user address:', error));
};